import axios from "axios";
import { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";
import Turnstile from "react-turnstile";
import fondo from "../img/fondo.jpg";
import logo from "../img/logo.png";
import { Footer } from "../componentes/footer";
const KEY_CAPTCHA = process.env.REACT_APP_CLAVE_RECAPTCHA;
const URI_LOGIN =
	process.env.REACT_APP_DOMINIO + process.env.REACT_APP_PUERTO + "/login";

const MySwal = withReactContent(Swal);

export const CompLogin = () => {
	const [dniLogin, setDniLogin] = useState("");
	const [passLogin, setPassLogin] = useState("");
	// const [captchaToken, setCaptchaToken] = useState(null);
	const navigate = useNavigate();
	// const recaptchaRef = useRef(null);
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	// const handleCaptchaChange = (token) => {
	// 	setCaptchaToken(token);
	// };

	const logear = async (e) => {
		e.preventDefault();
		// if (dniLogin !== "" || passLogin !== "") {
		// if (!captchaToken) {
		// 	MySwal.fire({
		// 		text: "Por favor, completa el reCAPTCHA.",
		// 		confirmButtonText: "Ok",
		// 	});
		// 	return;
		// }

		try {
			const logearse = await axios.post(
				URI_LOGIN,
				{
					dni: dniLogin,
					password: passLogin,
					// token: captchaToken,
				},
				{
					withCredentials: true,
					credentials: "include",
					headers: {
						"Access-Control-Allow-Origin": "*",
						"Content-Type": "application/json",
					},
				}
			);
			// console.log(logearse)
			if (logearse.data.code === 200) {
				// MySwal.fire({
				// 	text: "Bienvenido al laboratorio",
				// 	imageHeight: 65,
				// 	confirmButtonText: "Ok",
				// 	customClass: {
				// 		confirmButton: "btn-confirmar",
				// 	},
				// });
				const now = new Date();
				const expiration = new Date(now.getTime() + 90 * 24 * 60 * 60 * 1000);
				localStorage.setItem(
					"camulabo_valid_session",
					logearse.data.token,
					expiration
				);
				navigate("/panel");
			} else if (logearse.data.code === 302 || logearse.data.code === 409) {
				MySwal.fire({
					text: "Usuario o contraseña incorrectos",
					imageHeight: 50,
					confirmButtonText: "Ok",
					icon: "error",
					customClass: {
						confirmButton: "btn-confirmar",
					},
				}).then(() => {
					// Restablecer captcha al hacer clic en "Ok"
					// if (recaptchaRef.current) {
					// 	recaptchaRef.current.reset();
					// }
				});
			} else if (logearse.data.code === 301) {
				MySwal.fire({
					text: "Campos vacíos",
					imageHeight: 50,
					confirmButtonText: "Ok",
					icon: "error",
					customClass: {
						confirmButton: "btn-confirmar",
					},
				}).then(() => {
					// Restablecer captcha al hacer clic en "Ok"
					// if (recaptchaRef.current) {
					// 	recaptchaRef.current.reset();
					// }
				});
			} 
			// else if (logearse.data.code === 403) {
			// 	MySwal.fire({
			// 		text: "Captcha inválido",
			// 		imageHeight: 50,
			// 		confirmButtonText: "Ok",
			// 		icon: "error",
			// 		customClass: {
			// 			confirmButton: "btn-confirmar",
			// 		},
			// 	});
			// 	navigate("/");
			// }
		} catch (error) {
			MySwal.fire({
				text: "Error en el inicio de sesión",
				confirmButtonText: "Ok",
				icon: "error",
				customClass: {
					confirmButton: "btn-confirmar",
				},
			});
			navigate("/");
		}
		// } else {
		// 	MySwal.fire({
		// 		text: "DNI o Contraseña vació",
		// 		confirmButtonText: "Ok",
		// 		icon: "error",
		// 		customClass: {
		// 			confirmButton: "btn-confirmar",
		// 		},
		// 	});
		// 	navigate("/");
		// }
	};

	return (
		<>
			<div
				className="body"
				style={{
					margin: "auto",
					minHeight: "100vh",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}>
				<div
					className="container-login-nuevo text-center p-0"
					style={{
						width: "100%",
						maxWidth: "22em",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						padding: "20px",
					}}>
					<div className="form-container">
						<img src={logo} alt="Logo" className="form-logo " />
						<h5 className="form-title">Ingrese sus credenciales</h5>
						<div>
							<form className="form-login" id="LoginForm" onSubmit={logear}>
								<input
									type="number"
									placeholder={"DNI"}
									id="dniLogin"
									className="input-login"
									onChange={(e) => setDniLogin(e.target.value)}
									value={dniLogin}
									required
								/>
								<div className="password-container">
									<input
										type={showPassword ? "text" : "password"}
										placeholder={"Contraseña"}
										id="passLogin"
										className="input-login"
										onChange={(e) => setPassLogin(e.target.value)}
										value={passLogin}
										required
									/>
									<span className="eye-icon" onClick={togglePasswordVisibility}>
										{showPassword ? <FaEye /> : <FaEyeSlash />}
									</span>
								</div>
								<Link to="/password/nueva" className="forgot-password-link">
									{"¿Olvidó su contraseña?"}
								</Link>

								<div className="turnstile-container">
									{/* <ReCAPTCHA
										ref={recaptchaRef}
										sitekey={KEY_CAPTCHA}
										onChange={handleCaptchaChange}
									/> */}
									{/* <Turnstile
										sitekey={KEY_CAPTCHA}
										onVerify={(token) => setCaptchaToken(token)}
										ref={recaptchaRef}
									/> */}
								</div>

								<button type="submit" className="btn-login">
									{"INGRESAR"}
								</button>
							</form>
						</div>
					</div>
				</div>{" "}
			</div>
			<Footer />
		</>
	);
};
